import { useEffect, useState, useMemo, useCallback  } from "react";

// Componentes
import TituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../../componentsUI/formularios/button/BotonAction.js";

import { useGastosxMetodo } from "../../../../contexto/provider/GastosVistasContext.js";

import "../../../../componentsUI/tablas/tablaGenerica.css";

export default function TablaGastoXCategoria({ rowsPerPage = 8 }) {
  const { listarGastosMetodoCategoria } = useGastosxMetodo();

  const [paginaActual, setPaginaActual] = useState(1);
  const [gastos, setGastos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const limiteFilas = Math.min(rowsPerPage, 20);
  const totalPaginas = Math.ceil(gastos.length / limiteFilas);

  const datosPaginados = useMemo(() => {
    const inicio = (paginaActual - 1) * limiteFilas;
    const fin = inicio + limiteFilas;
    return gastos.slice(inicio, fin);
  }, [gastos, paginaActual, limiteFilas]);

  const cambiarPagina = (numero) => {
    if (numero >= 1 && numero <= totalPaginas) {
      setPaginaActual(numero);
    }
  };

const cargarDatos = useCallback(async () => {
  try {
    console.log("Cargando gastos por categoría");

    setLoading(true);
    setError(null);

    const data = await listarGastosMetodoCategoria();

    setGastos(data ?? []);

    console.log("Gastos cargados correctamente", {
      cantidad: data?.length || 0,
    });

  } catch (err) {

    console.error("Error al cargar gastos", err);
    setError(err.message || "Error al cargar gastos");

  } finally {

    setLoading(false);

  }
}, [listarGastosMetodoCategoria]);

useEffect(() => {
  cargarDatos();
}, [cargarDatos]);

  return (
    <div>
      <TituloModulo titulo="Gastos por categoria" />

      <BotonAccion onClick={cargarDatos}>Cargar</BotonAccion>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="tabla-container">
        <div className="tabla-scroll">
          <table className="tabla-reporte">
            <thead>
              <tr>
                <th className="col-1">Fecha</th>
                <th className="col-2">Método</th>
                <th className="col-3">Cantidad</th>
                <th className="col-4">Total</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4">Cargando...</td>
                </tr>
              ) : datosPaginados.length === 0 ? (
                <tr>
                  <td colSpan="4">Sin registros</td>
                </tr>
              ) : (
                datosPaginados.map((fila, index) => (
                  <tr key={`${fila.fecha}-${fila.categoria}-${index}`}>
                    <td>{fila.fecha}</td>

                    <td>{fila.categoria}</td>

                    <td className="col-num">{fila.cantidad}</td>

                    <td className="col-num col-total">
                      {new Intl.NumberFormat("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                      }).format(fila.total)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="paginacion">
          <button onClick={() => cambiarPagina(paginaActual - 1)}>←</button>

          <span>
            Página {paginaActual} de {totalPaginas || 1}
          </span>
          <button onClick={() => cambiarPagina(paginaActual + 1)}>→</button>
        </div>
      </div>
    </div>
  );
}
